import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Table } from 'semantic-ui-react';

import SnukTableLoadMore from './SnukTableLoadMore';
import SnukTableRow from './SnukTableRow';

const SnukTableBody = (props) => {
  const {
    t, shape, editable, content, loadMoreAction, loadMoreActionArgs, ...rest
  } = props;
  let colSpan = 1;
  shape.forEach((info) => {
    colSpan += parseInt(info.header.colSpan, 10) || 1;
  });
  colSpan += editable ? 1 : 0;
  colSpan = colSpan.toString();
  return (
    <Table.Body>
      {content.allIds.length > 0
        ? (
          <Fragment>
            {content.allIds.map(id => (
              <SnukTableRow key={id} shape={shape} values={content.byId[id]} editable={editable} {...rest} />
            ))}
            {content.nextPageCursor
              ? (
                <SnukTableLoadMore
                  colSpan={colSpan}
                  isLoadingMore={content.isLoadingMore}
                  loadMoreAction={loadMoreAction}
                  loadMoreActionArgs={loadMoreActionArgs}
                />
              ) : <Fragment />
            }
          </Fragment>
        )
        : (
          <Table.Row>
            <Table.Cell colSpan={colSpan} textAlign="center">
              <span>{t('common.nodata')}.</span>
            </Table.Cell>
          </Table.Row>
        )
      }
    </Table.Body>
  );
};

SnukTableBody.propTypes = {
  t: PropTypes.func.isRequired,
  content: PropTypes.shape({
    isLoadingMore: PropTypes.bool,
    byId: PropTypes.shape({}).isRequired,
    allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  shape: PropTypes.shape({}).isRequired,
  editable: PropTypes.bool.isRequired,
  loadMoreAction: PropTypes.func,
  loadMoreActionArgs: PropTypes.arrayOf(PropTypes.any),
};

SnukTableBody.defaultProps = {
  loadMoreActionArgs: [],
  loadMoreAction: null,
};

export default translate()(SnukTableBody);



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableBody.js